import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AboutPage from './pages/about';
import ContactPage from './pages/contact';
import WorkPage from './pages/works';
import Gallery from './pages/galary/Galary';
import SkillPage from './pages/skill-page';
import App from './App';
import './index.css';
import HomePage from './pages/home';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, path: '', element: <HomePage /> },
      {
        path: 'about',
        element: <AboutPage />,
      },
      { path: 'contact', element: <ContactPage /> },
      { path: 'my-skill', element: <SkillPage /> },
      { path: 'my-works', element: <WorkPage /> },
      { path: 'gallery', element: <Gallery /> },
    ],
  },
]);

createRoot(document.getElementById('root')).render(
  <RouterProvider router={router} />
);
